import { View } from 'react-native'
import { SoccerKit } from '../../ui/SoccerKit/SoccerKit'
import { CountryFlag } from '../../worldcup/CountryFlag/CountryFlag'
import { getTeamKitConfigFromTeam } from '../../../helpers/teamKit.helper'
import type { LeagueStandingsTableStyles } from './LeagueStandingsTable.styles'

interface TeamKitCellProps {
  displayName: string
  countryCode?: string | null
  kitPrimary?: string | null
  kitSecondary?: string | null
  kitType?: string | null
  styles: LeagueStandingsTableStyles
  kitSize: number
}

export function TeamKitCell({
  displayName,
  countryCode,
  kitPrimary,
  kitSecondary,
  kitType,
  styles,
  kitSize,
}: TeamKitCellProps) {
  const kit = getTeamKitConfigFromTeam({
    name: displayName,
    kitPrimary: kitPrimary ?? null,
    kitSecondary: kitSecondary ?? null,
    kitType: kitType ?? null,
  })
  return (
    <View style={styles.teamKitColumn}>
      {countryCode != null && countryCode !== '' ? (
        <CountryFlag
          countryCode={countryCode}
          kitFallback={kit}
          size="mini"
          accessibilityLabel={displayName}
        />
      ) : (
        <SoccerKit
          primary={kit.primary}
          secondary={kit.secondary}
          type={kit.type}
          size={kitSize}
        />
      )}
    </View>
  )
}
